import { Stack, Tabs, TabList, Tab, TabPanels, TabPanel } from "@carbon/react";
import { CardComponent, CardRow } from "../../../components/Layouts/Card.styles";
import { HeatMap, Dashboard } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import Card from '../../../components/Layouts/Card';
import { Iframe } from "../../../components/Basics/Iframe.styles";


const AcopiosHistoricos = () => {
  return (
    <Stack gap={3}>
      <CardComponent width="100%">
        <Card justifyContent='flex-start' >
          <Dashboard size={18} />
          <Typography className='cds--type-heading-compact-01'>
            MONITOREO DE ACOPIOS HISTORICO
          </Typography>
        </Card>
        <CardRow width='inherit'>
          <Card width='100%' padding="0" flexDirection='column'>
            <Iframe title="Monitoring map" src="https://grafana.terrestra.tech/d/b1a47df6-fa5e-4526-9528-e80f3c47ad89/acopios-historico-v2-copy?orgId=1&from=1779650956695&to=1779737356695&kiosk" width="100%" height="100%" />
          </Card>
        </CardRow>
      </CardComponent>
    </Stack>
  )
}

export default AcopiosHistoricos